// extracted by mini-css-extract-plugin
module.exports = {"categoryWrapper":"style_categoryWrapper__24JVB","categoryBar":"style_categoryBar__FDNyW"};